import React, { useState, useEffect } from 'react';
import { PenTool, CheckCircle, Loader } from 'lucide-react';
import { formatLocalDate } from '../utils/date';

const DailyFeedbackWidget = ({ date, initialNotes = '' }) => {
  const [notes, setNotes] = useState(initialNotes);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    setNotes(initialNotes);
  }, [initialNotes]);

  const handleSave = async () => {
    if (!notes.trim()) return;
    setSaving(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/user/daily-health', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          date: date || formatLocalDate(new Date()),
          athleteNotes: notes
        })
      });
      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 2000);
      }
    } catch (err) {
      console.error('Error saving feedback:', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      background: 'rgba(255,255,255,0.03)',
      border: '1px solid rgba(255,255,255,0.05)',
      borderRadius: '12px',
      padding: '1rem',
      marginTop: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', color: 'var(--text-secondary)' }}>
        <PenTool size={16} />
        <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>Diario de Sensaciones</span>
      </div>
      <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', margin: 0 }}>
        ¿Alguna molestia, dolor de rodilla o fatiga extrema? Anótalo para que la IA adapte tus próximos entrenamientos.
      </p>
      <div style={{ position: 'relative', marginTop: '0.5rem' }}>
        <textarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          placeholder="Ej: Hoy me duelen un poco las rodillas tras la bici..."
          style={{
            width: '100%',
            minHeight: '60px',
            background: 'rgba(0,0,0,0.2)',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            padding: '0.75rem',
            color: 'var(--text-primary)',
            fontSize: '0.9rem',
            resize: 'vertical',
            fontFamily: 'inherit'
          }}
        />
        <button
          onClick={handleSave}
          disabled={saving || !notes.trim()}
          style={{
            position: 'absolute',
            bottom: '0.5rem',
            right: '0.5rem',
            background: saved ? '#10b981' : 'var(--glass-button-bg)',
            border: '1px solid var(--glass-border)',
            borderRadius: '6px',
            padding: '0.3rem 0.6rem',
            color: '#fff',
            fontSize: '0.75rem',
            fontWeight: 600,
            cursor: saving || !notes.trim() ? 'not-allowed' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.3rem',
            transition: 'all 0.2s',
            opacity: (!notes.trim() && !saved) ? 0 : 1
          }}
        >
          {saving ? <Loader size={12} className="animate-spin" /> : (saved ? <CheckCircle size={12} /> : 'Guardar')}
          {saving ? 'Guardando' : (saved ? 'Guardado' : 'Guardar')}
        </button>
      </div>
    </div>
  );
};

export default DailyFeedbackWidget;
